var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSlug)?_c('div',{staticClass:"flex flex-col items-center gap-4 text-12 bg-white p-8 rounded-sm"},[_c('WFTranslate',{attrs:{"k":"offer-qr"}}),_c('img',{staticClass:"w-80",attrs:{"src":_vm.qr}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }